import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

export interface TouchSelectOption {
  value: any;
  label: string;
  // allow passthrough for any additional fields
  [key: string]: any;
}

@Component({
  selector: 'app-touch-select',
  templateUrl: './touch-select.component.html',
  styleUrls: ['./touch-select.component.scss'],
})
export class TouchSelectComponent {
  @HostBinding('class.touch-select-host') hostClass = true;

  @Input() options: TouchSelectOption[] = [];
  @Input() placeholder: string = 'Select…';
  @Input() disabled = false;
  @Input() optionLabelKey: string = 'label';
  @Input() optionValueKey: string = 'value';

  @Input() twoStepMode = false;
  @Input() dependentOptions: TouchSelectOption[] | null | undefined = null;
  @Input() secondPlaceholder: string = 'Select…';
  @Input() secondLoading: boolean = false;
  @Input() centerItemLabel: boolean = false;

  @Output() selected = new EventEmitter<TouchSelectOption>();
  @Output() firstSelected = new EventEmitter<TouchSelectOption>();

  isOpen = false;
  current?: TouchSelectOption;
  step: 'first' | 'second' = 'first';

  get displayLabel(): string {
    return this.current ? this.current[this.optionLabelKey] ?? this.current.label : this.placeholder;
  }

  open() {
    if (this.disabled) return;
    this.isOpen = true;
    this.step = 'first';
  }

  handleVisibleChange(v: boolean) {
    this.isOpen = v;
  }

  choose(option: TouchSelectOption) {
    if (this.twoStepMode && this.step === 'first') {
      this.current = option;
      this.firstSelected.emit(option);
      this.step = 'second';
      return;
    }
    this.current = option;
    this.selected.emit(option);
    this.isOpen = false;
  }

  backToFirst() {
    if (!this.twoStepMode) return;
    this.step = 'first';
  }

  close() {
    this.isOpen = false;
  }
}
